import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="password-toggle"
export default class extends Controller {
  static targets = [ "input" ]

  connect() {
    this.createToggleButtons();
  }

  createToggleButtons() {
    // 找到原本的 eye 按鈕
    const originalButton = this.element.querySelector('.btn');
    if (!originalButton) return;

    // 複製原本按鈕的結構來創建隱藏按鈕
    this.hideButton = originalButton.cloneNode(true);
    this.hideButton.classList.add('d-none');
    this.hideButton.classList.remove('d-block');
    this.hideButton.setAttribute('data-action', 'click->password-toggle#hide');
    
    // 替換 icon 為 eye-slash
    const originalIcon = this.hideButton.querySelector('svg');
    if (originalIcon) {
      originalIcon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />';
    }

    // 設定原本按鈕的 action
    originalButton.setAttribute('data-action', 'click->password-toggle#show');
    this.showButton = originalButton;

    // 將隱藏按鈕插入到原本按鈕後面
    originalButton.parentNode.insertBefore(this.hideButton, originalButton.nextSibling);
  }

  show(e) {
    e.preventDefault();
    this.inputTarget.type = "text";
    this.showButton.classList.add("d-none");
    this.showButton.classList.remove("d-block");
    this.hideButton.classList.add("d-block");
    this.hideButton.classList.remove("d-none");
  }

  hide(e) {
    e.preventDefault();
    this.inputTarget.type = "password";
    this.hideButton.classList.add("d-none");
    this.hideButton.classList.remove("d-block");
    this.showButton.classList.add("d-block");
    this.showButton.classList.remove("d-none");
  }
} 